import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreAllAcademicYears as apiRestoreAll } from "../../api/apiAcademicYears";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useRestoreAllAcademicYears() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: restoreAllAcademicYears, isPending: isRestore } = useMutation({
        mutationFn: (req) => apiRestoreAll(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["academicYears"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { restoreAllAcademicYears, isRestore };
}
